import { render, staticRenderFns } from "./premiumForm.vue?vue&type=template&id=ccb24f80&scoped=true"
import script from "./premiumForm.vue?vue&type=script&lang=js"
export * from "./premiumForm.vue?vue&type=script&lang=js"
import style0 from "./premiumForm.vue?vue&type=style&index=0&id=ccb24f80&lang=scss&scoped=true"
import style1 from "./premiumForm.vue?vue&type=style&index=1&id=ccb24f80&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb24f80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccb24f80')) {
      api.createRecord('ccb24f80', component.options)
    } else {
      api.reload('ccb24f80', component.options)
    }
    module.hot.accept("./premiumForm.vue?vue&type=template&id=ccb24f80&scoped=true", function () {
      api.rerender('ccb24f80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/productManage/productFrom/premiumForm.vue"
export default component.exports